import util from '@bmp-vue/core/api/util'

const controller = 'ArranjoPagamentos'
export default Object.assign({}, util.GetCrud(controller, ['get', 'getall', 'persist']), {
    GetAllRecusa: function (codigoArranjoPagamentos, dto) {
        return util.Axios.GetAll(`${controller}/${codigoArranjoPagamentos}/recusa`, dto)
    },
    PostRecusa: function (dto) {
        return util.Axios.Post(`${controller}/${dto.codigoArranjoPagamentos}/recusa`, dto)
    },
    PutRecusa: function (dto) {
        return util.Axios.Put(`${controller}/${dto.codigoArranjoPagamentos}/recusa`, dto.codigo, dto)
    },
})
